export const modalSettings = {
  maxWidth: '340px',
  minWidth: '340px',
};
